import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { theme } from "../configs/theme.config";
import PropTypes from 'prop-types';

const ChakraUiProvider = ({ children }) => {
  const toastOptions = {
    defaultOptions: {
      position: 'top',
    }
  };

  return (
    <ChakraProvider theme={theme} toastOptions={toastOptions}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      {children}
    </ChakraProvider>
  );
};
ChakraUiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChakraUiProvider;
